import React from 'react';
import RefundsContainer from '../../components/modules/Reports/Refunds/RefundsContainer';

const Refunds = () => {
  return <RefundsContainer />;
};

export default Refunds;
